import { ConditionOperatorEnum, type Condition } from '@repo/api-gw-sdk';

import { BACKUP_STATUS_PROPERTY } from '../queryBuilder/propertyNames';

export const createBackupStatusNotInCondition = (
  values: string[]
): Condition => ({
  property: BACKUP_STATUS_PROPERTY,
  operator: ConditionOperatorEnum.NotIn,
  value: values,
});
